const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewError403 = () => import('./error403')
const ViewError404 = () => import('./error404')
const ViewError500 = () => import('./error500')
const ViewError502 = () => import('./error502')

export default [
  {
    path: '/error',
    component: DefaultContainer,
    children: [
      { path: '403', name: 'Error403', component: ViewError403 },
      { path: '404', name: 'Error404', component: ViewError404 },
      { path: '500', name: 'Error500', component: ViewError500 },
      { path: '502', name: 'Error502', component: ViewError502 },
    ],
  },

  // catch-all GLOBAL: tiene que ir al final de TODO el array de routes
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Error404' }, // o component directo si preferís
  },
]

/*
const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewError403 = () => import('./error403')
const ViewError404 = () => import('./error404')
const ViewError500 = () => import('./error500')
const ViewError502 = () => import('./error502')

const router = [
  {
    path: '/error',
    component: DefaultContainer,
    children: [
      {
        path: '403',
        name: 'Error403',
        component: ViewError403,
      },
      {
        path: '404',
        name: 'Error404',
        component: ViewError404,
      },
      {
        path: '500',
        name: 'Error500',
        component: ViewError500,
      },
      {
        path: '502',
        name: 'Error502',
        component: ViewError502,
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'Error404',
        component: ViewError404,
      },
    ],
  },
]

export default router
*/